module.exports = __webpack_public_path__ + "assets/2d4131dff27ce7e1c38e454ce2987c17.mp3";